import crud from './_crud'
import { callApi } from 'utils/api'
import { showSuccessMessage } from 'utils/messages'
const entity = 'pending_file';
const actions = crud('pending_file', 'El Documento Pendiente', 'Los Documentos Pendientes');
const messagePluralEntity = 'Los Documentos Pendientes';

const getAuthContext = (state) => {
  const activeRole = typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem('active_role')
    : null

  if (activeRole === 'client' && state?.app?.client?.token) {
    return {
      token: state.app.client.token,
      sys_company_id: state?.app?.client?.sys_company_id,
    }
  }

  if (activeRole === 'supplier' && state?.app?.supplier?.token) {
    return {
      token: state.app.supplier.token,
      sys_company_id: state?.app?.supplier?.sys_company_id,
    }
  }

  if (activeRole === 'user' && state?.app?.user?.token) {
    return {
      token: state.app.user.token,
      sys_company_id: state?.app?.user?.sys_company_id,
    }
  }

  if (state?.app?.user?.token) {
    return {
      token: state.app.user.token,
      sys_company_id: state?.app?.user?.sys_company_id,
    }
  }

  if (state?.app?.supplier?.token) {
    return {
      token: state.app.supplier.token,
      sys_company_id: state?.app?.supplier?.sys_company_id,
    }
  }

  if (state?.app?.client?.token) {
    return {
      token: state.app.client.token,
      sys_company_id: state?.app?.client?.sys_company_id,
    }
  }

  return { token: null, sys_company_id: null }
}

const loadPendingFiles = (options) => {
    return async (dispatch, getState) => {
      const state = getState();

      if(Object.keys(state[`${entity}s`].entities).length <= 2 || options.force === true) {
        dispatch({
          type: `FETCH_${entity.toUpperCase()}S`,
        })

        let token;

        if(state.app.supplier){
          token = state.app.supplier.token;
        }else if(state.app.client){
          token = state.app.client.token;
        }

        const res = await callApi(`/${entity}`, {
            method: 'GET',
            headers: {
              Authorization: token
            },
            params: options.params
        });
        
        dispatch({
            type: `LOAD_${entity.toUpperCase()}S`,
            response: res.body,
          })
  
          return res.body;
      }
    };
};

const approveFiles = ({ approvedFiles }) => {
  return async (dispatch, getState) => {
    console.log(approvedFiles, "ep")
    const state = getState();
    try {
      // Llamar a la API para aprobar los archivos
      const res = await callApi(`/${entity}/approve_files_bulk`, {
        method: 'POST',
        headers: {
          Authorization: state.app.user.token, // Token de autenticación
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ approvedFiles }), // Serializar el cuerpo a JSON
        successMessage: 'Archivos aprobados correctamente',
      });
      
      return res.body; // Retornar la respuesta del backend
    } catch (error) {
      console.log(error);
      return null;
    }
  };
};

const bulkSyncPendingFiles = ({ deleteItems, updateItems, createItems }, options = {}) => {
    return async (dispatch, getState) => {
      const state = getState();
      const { token, sys_company_id } = getAuthContext(state)

      let res = await callApi(`/${entity}/bulkSync`, {
        method: 'POST',
        body: JSON.stringify({
          deleteItems,
          updateItems,
          createItems,
          sys_company_id: sys_company_id
        }),
        headers: {
          Authorization: token
        },
        successMessage: `Se sincronizaron ${messagePluralEntity} correctamente.`
      })

      let stored_item = res.body
      return dispatch(loadPendingFiles({...options,
        force: true
      }))
    }
}

const handleFileUpload = (file, rowID) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { token } = getAuthContext(state)

    try {
      // Hacer la llamada al API para subir el archivo
      const res = await callApi(`/${entity}/upload_file`, {
        method: 'POST',
        json: false,  // No necesitamos JSON headers ya que enviamos FormData
        body: {
          file: file,
        },
        headers: {
          Authorization: token  // Usamos el token de supplier
        }
      });

      console.log(res)
      if (res.status === 200) {
        const { file_url } = res.body;  // Obtenemos la URL generada por el backend

        // Devolver la URL del archivo para manejarla en la interfaz
        return file_url;
      } else {
        console.error('Error subiendo archivo:', res.body);
        return null;
      }
    } catch (error) {
      console.error('Error en la petición:', error);
      return null;
    }
  };
};

const handleFileUploadClient = (file, rowID) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { token } = getAuthContext(state)

    try {
      // Hacer la llamada al API para subir el archivo
      const res = await callApi(`/${entity}/upload_file`, {
        method: 'POST',
        json: false,  // No necesitamos JSON headers ya que enviamos FormData
        body: {
          file: file,
        },
        headers: {
          Authorization: token  // Usamos el token de supplier
        }
      });

      console.log(res)
      if (res.status === 200) {
        const { file_url } = res.body;  // Obtenemos la URL generada por el backend

        // Devolver la URL del archivo para manejarla en la interfaz
        return file_url;
      } else {
        console.error('Error subiendo archivo:', res.body);
        return null;
      }
    } catch (error) {
      console.error('Error en la petición:', error);
      return null;
    }
  };
};

export default{
    ...actions,
    loadPendingFiles,
    bulkSyncPendingFiles,
    handleFileUpload,
    approveFiles,
};
